import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HaloToastService, IToast } from './halo-toast.service';

@Component({
  selector: 'app-halo-toast',
  templateUrl: './halo-toast.component.html',
  styleUrls: ['./halo-toast.component.scss'],
})
export class HaloToastComponent implements OnInit {
  // string sources
  public toasts: IToast[] = [];

  constructor(private toast: HaloToastService, private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.toast.add.subscribe((res: IToast) => {
      this.toasts = [];
      this.toasts.push(res);
    });
    this.toast.remove.subscribe((res: number) => this.onClose(res));
  }

  onClose(UUID: number) {
    this.toasts = this.toasts.filter(toast => {
      return toast.UUID !== UUID;
    });
  }
}
